// @ts-ignore
/* eslint-disable */
import request from '../../utils/request';

/** 客户投诉与建议 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 POST /customer/complaint */
export async function customerComplaintUsingPOST(
  body: API.CustomerComplaintReq,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultVoid>('/customer/complaint', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}
